import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MainService } from './main.service';
import { AuthPayload, AuthResponse } from '../models/auth/auth.model';
import { UserSendOtpPayload, UserSendOtpResponse } from '../models/auth/user-send-otp.model';
import { UserVerifyOtpPayload, UserVerifyOtpResponse } from '../models/auth/user-verify-otp.model';
import { UpdatePasswordPayload, UpdatePasswordResponse } from '../models/auth/update-password.model';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';




@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private router: Router,
    private dialog: MatDialog,
    private mainService: MainService,
  ) { }
  login(payload: AuthPayload): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(environment.API_URL + '/auth/specialUser', payload).pipe(
      // map(res => this.commonService.attachImageUrl(res, ['thumbPic']))
    );
  }
  userSendOtp(payload: UserSendOtpPayload): Observable<UserSendOtpResponse> {
    return this.http.post<UserSendOtpResponse>(environment.API_URL + '/otp/userSendOtp', payload);
  }
  userVerifyOtp(payload: UserVerifyOtpPayload): Observable<UserVerifyOtpResponse> {
    return this.http.post<UserVerifyOtpResponse>(environment.API_URL + '/otp/verifyOtp', payload);
  }
  updatePassword(payload: UpdatePasswordPayload): Observable<UpdatePasswordResponse> {
    return this.http.post<UpdatePasswordResponse>(environment.API_URL + '/otp/forgetPassword', payload);
  }
  get token(): string {
    return localStorage.getItem('token');
  }

  hasRole(neededRoles: number[]) {
    if (!neededRoles) {
      return true;
    }

    if (!neededRoles.length) {
      return true;
    }

    const myRole = localStorage.getItem('role_id');
    const index = neededRoles.indexOf(Number(myRole));
    return index !== -1;
  }

  updateUserData(serverUserResponse: any) {
    localStorage.setItem('first_name', serverUserResponse.first_name);
    localStorage.setItem('last_name', serverUserResponse.last_name);

    const currentRoleID = +localStorage.getItem('role_id');
    if (serverUserResponse.role_id !== currentRoleID) {
      this.mainService.showErrorSnackBar('دسترسی یا نقش‌های شما تغییر کرده است. لطفا دوباره وراد شوید.');
      this.signOut(true);
    }
  }

  signinByPhone(phone: string, password: string) {
    return this.http.post(environment.API_URL + '/auth/specialUser', {
      username: phone,
      password,
    });
  }

  signup(firstName: string, lastName: string, email: string, password: string) {
    return this.http.post(environment.API_URL + '/v1/users/register', {
      first_name: firstName,
      last_name: lastName,
      email,
      password,
    });
  }

  signOut(force?: boolean) {
    if (force) {
      localStorage.removeItem('token');
      this.router.navigate(['/login']);
      setTimeout(() => {
        localStorage.clear();
      }, 1000);
      return;
    }

    const ref = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      autoFocus: false,
      direction: 'rtl',
      data: {
        title: 'خروج از حساب',
        message: 'آیا برای خروج از حساب کاربری اطمینان دارید؟'
      }
    });

    ref.afterClosed().subscribe(res => {
      if (res) {
        localStorage.removeItem('token');
        this.router.navigate(['/login']);
        setTimeout(() => {
          localStorage.clear();
        }, 1000);
      }
    });
  }
}

